import './App.css';
import { Link } from 'react-router-dom';
import { raffleExplanation } from './Signup';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img
          src="/CatastrobeeTitleCard.png"
          alt="Catastrobee Title"
          className="title-image"
        />
      </header>
      <p className="announcement">The release date for Catastrobee will be announced soon! For now, watch the trailer below.</p>
        <main>
          <div className="content home-content">
            <iframe 
              width="560" 
              height="315" 
              src="https://www.youtube.com/embed/rN9awQU8Clw?si=V2vSkllaKEOk3mjj" 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              referrerPolicy="strict-origin-when-cross-origin" 
              allowFullScreen
            />

            <div className="form-column">
              <p className="form-title">Sign up for reminders and win merch!</p>
              <p className="smaller-text">{raffleExplanation}</p>

              <Link to="/signup" className="submit-btn">Go to Sign Up</Link>
            </div>
          </div>
        </main>
    </div>
  );
}

export default App;
